import React from 'react';
import { normalizeSportEventId } from '@/nikeone/domain/sportevent';
import { useReframe } from 'nike-re-framejs';
import Immutable from 'immutable';
import { CashinButton } from './CashinButton';

function CashinRow({ cashinOffer }) {
    if (!cashinOffer || cashinOffer.status === 'Finished' || cashinOffer === 'NotAvailable') {
        return null;
    }
    const disabled = cashinOffer.status === 'InProgress';
    return (
        <div className="cashin-row">
            <CashinButton cashinOffer={cashinOffer} disabled={disabled} />
        </div>
    );
}

export function EventCashinOffers({ eventId }) {
    const derefSub = useReframe();
    const normalizedEventId = normalizeSportEventId(eventId);
    const eventCashinOffers = derefSub(['ticketus/cashin-offer/sport-events', normalizedEventId]) || Immutable.Set();

    if (!eventCashinOffers.size) {
        return null;
    }

    return (
        <div className="cashin-wrap">
            {eventCashinOffers
                .map(ticketCashin => <CashinRow key={ticketCashin.get('ticketId')} cashinOffer={ticketCashin.toJS()} />)
                .toArray()}
        </div>
    );
}
